import { useLocalization } from '../../../../common/providers/LocaleProvider';
export var useProductCount = function (count, isMobile) {
    var r = useLocalization().r;
    if (isMobile || !count) {
        return count;
    }
    var translationKey = count === 1 ? 'h24_one_product' : 'h24_many_products';
    return r.t(translationKey, { count: count });
};
